class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.setupHover();
  }

  setupHover() {
    const details = this.mainDetailsToggle;
    const summary = details.querySelector('summary');
    const submenu = details.querySelector('.header__submenu');
    
    if (!summary || !submenu) return;

    let hoverTimeout;

    const openMenu = () => {
      if (window.innerWidth >= 990) {
        clearTimeout(hoverTimeout);
        details.setAttribute('open', '');
      }
    };

    const closeMenu = () => {
      if (window.innerWidth >= 990) {
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(() => {
          // Verificar se o mouse ainda não está sobre o details, submenu ou submenus aninhados
          const isHovering = details.matches(':hover') || 
                            submenu.matches(':hover') || 
                            summary.matches(':hover') ||
                            details.querySelector('.header__submenu:hover');
          if (!isHovering) {
            details.removeAttribute('open');
          }
        }, 150);
      }
    };

    // Abrir no hover do summary
    summary.addEventListener('mouseenter', openMenu);
    
    // Abrir no hover do details
    details.addEventListener('mouseenter', openMenu);
    
    // Manter aberto quando o mouse está sobre o submenu
    submenu.addEventListener('mouseenter', openMenu);

    // Fechar quando sair do details (que contém summary e submenu)
    details.addEventListener('mouseleave', closeMenu);

    // Configurar hover para submenus aninhados dentro deste submenu
    const nestedDetails = submenu.querySelectorAll('details');
    nestedDetails.forEach(nestedDetail => {
      const nestedSubmenu = nestedDetail.querySelector('.header__submenu');
      if (nestedSubmenu) {
        nestedDetail.addEventListener('mouseenter', () => {
          if (window.innerWidth >= 990) {
            nestedDetail.setAttribute('open', '');
          }
        });

        nestedDetail.addEventListener('mouseleave', () => {
          if (window.innerWidth >= 990) {
            setTimeout(() => {
              if (!nestedDetail.matches(':hover') && !nestedSubmenu.matches(':hover')) {
                nestedDetail.removeAttribute('open');
              }
            }, 150);
          }
        });

        nestedSubmenu.addEventListener('mouseenter', () => {
          if (window.innerWidth >= 990) {
            nestedDetail.setAttribute('open', '');
          }
        });
      }
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
